import { ListItem } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomIcon from "../../CustomIcon/CustomIcon";
import * as Styles from "../LandingInfo.styles";

interface LandingInfoItemProps {
  text: string;
}

export default function LandingInfoItem({ text }: LandingInfoItemProps) {
  return (
    <ListItem>
      <Styles.ItemIcon>
        <CustomIcon Icon={CheckCircleIcon} color="var(--color-primary)" />
      </Styles.ItemIcon>

      <Styles.ItemText>{text}</Styles.ItemText>
    </ListItem>
  );
}
